import React from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { withTranslation, WithTranslation } from "react-i18next";
import { FileChannelItem } from "../../../../../webapi/service/getFileChannels";
import { AppConfig } from "../../../../../common/constants";
import "../../../../../App.css";
import "../../projectdetail.css";

export interface IProps extends WithTranslation {
  /**
   * タイトル
   */
  title: string;
  /**
   * 見出し
   */
  caption: string;
  /**
   * ダイアログを表示する場合はtrue
   */
  show: boolean;
  /**
   * チャネル情報一覧
   */
  channels: FileChannelItem[];
  /**
   * OKボタンが押された場合に呼び出されます
   */
  onOk: (channels: string[]) => void;
  /**
   * キャンセルボタンが押された場合に呼び出されます
   */
  onCancel: () => void;
}

interface ICheckItem {
  /**
   * ID
   */
  checkid: string;
  /**
   * チェックがONの場合true
   */
  checked: boolean;
}

interface IState {
  /**
   * チェック項目一覧
   */
  checkItems: ICheckItem[];
}

class ChannelSettingDialog extends React.Component<IProps, IState> {
  private readonly max_channels = AppConfig.MAX_SELECT_CHANNELS;

  constructor(props: IProps) {
    super(props);

    this.state = { checkItems: [] };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClickCancel = this.handleClickCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps: IProps) {
    const { channels } = this.props;
    const { checkItems } = this.state;
    if (
      (checkItems.length === 0 && channels.length > 0) ||
      channels.length !== prevProps.channels.length
    ) {
      const checkItems = channels.map((channel) => {
        return {
          checkid: channel.chname,
          checked: false,
        };
      });
      this.setState({ checkItems: checkItems });
    }
  }

  handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const checkItems = this.state.checkItems.filter((item) => {
      return item.checked === true;
    });
    const channels = checkItems.map((item) => {
      return item.checkid;
    });
    this.setState({ checkItems: [] });
    this.props.onOk(channels);
  }

  handleClickCancel() {
    this.setState({ checkItems: [] });
    this.props.onCancel();
  }

  handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const id = e.target.id;
    const checked = e.target.checked;
    const checkItems = this.state.checkItems.slice();
    checkItems.forEach((item) => {
      if (id === item.checkid) {
        item.checked = checked;
      }
    });
    this.setState({ checkItems: checkItems });
  }

  render() {
    const { channels, t } = this.props;
    const { checkItems } = this.state;
    const checkedItems = checkItems.filter((item) => {
      return item.checked === true;
    });
    const caption2 =
      channels.length > this.max_channels
        ? t("model_settings_channel_caption2")
        : "";
    const countCaption =
      channels.length > this.max_channels
        ? " ( " + checkedItems.length + " / " + this.max_channels + " )"
        : "";
    const channelList = channels.map((channel, i) => {
      const checkItem = checkItems.find((item) => {
        return item.checkid === channel.chname;
      });
      const check = checkItem ? (
        <Form.Check
          id={checkItem.checkid}
          checked={checkItem.checked}
          onChange={this.handleChange}
        ></Form.Check>
      ) : (
        ""
      );
      return (
        <tr key={i++}>
          <td>{check}</td>
          <td>{channel.chname}</td>
          <td className="item-tagid">{channel.tagid}</td>
          <td className="item-tagcomment">{channel.tagcomment}</td>
        </tr>
      );
    });
    const okBtn =
      0 < checkedItems.length && checkedItems.length <= this.max_channels ? (
        <Button className="dialog-button" variant="primary" type="submit">
          {t("model_settings_channel_ok")}
        </Button>
      ) : (
        ""
      );
    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClickCancel}
        animation={false}
        dialogClassName="channelsetting-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>{this.props.caption}</div>
            <div>
              <span>{caption2}</span>
              <span>{countCaption}</span>
            </div>
          </div>
          <Form onSubmit={this.handleSubmit}>
            <div className="channelsetting">
              <table>
                <thead>
                  <tr>
                    <th className="create">
                      {t("model_settings_channel_list_create")}
                    </th>
                    <th className="channel">
                      {t("model_settings_channel_list_channel")}
                    </th>
                    <th className="tagid">
                      {t("model_settings_channel_list_tagid")}
                    </th>
                    <th className="tagcommnt">
                      {t("model_settings_channel_list_tagcomment")}
                    </th>
                  </tr>
                </thead>
                <tbody>{channelList}</tbody>
              </table>
            </div>
            <div className="dialog-buttons">
              {okBtn}
              <Button
                className="dialog-button"
                variant="secondary"
                onClick={this.handleClickCancel}
              >
                {t("model_settings_channel_cancel")}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

/**
 * チャネル設定ダイアログ
 */
export default withTranslation()(ChannelSettingDialog);
